import axios from "axios";
import { API_URL } from "./const";

export const fetchDocumentations = async () => {
  return axios
    .get(`${API_URL}/coworking/documentation`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteDocumentation = async (id) => {
  return axios
    .delete(`${API_URL}/coworking/documentation/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const addDocumentation = async (data) => {
  return axios
    .post(`${API_URL}/coworking/documentation`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const getDocumentation = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/coworking/documentation/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const editDocumentation = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/coworking/documentation/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
